var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logo"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/logo.png"),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }